import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { API_URL } from "helper/Constants";
import UserService from "service/UserService";

const GlobalBalanceLimit = () => {
  const { t } = useTranslation();
  const userService = new UserService(API_URL);

  const [limit, setLimit] = useState("");
  const [botId, setBotId] = useState("");
  const [chatId, setChatId] = useState("");
  const [loading, setLoading] = useState(false);

  // store original values to detect changes
  const [initialValues, setInitialValues] = useState({
    limit: "",
    botId: "",
    chatId: "",
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        const settings = await userService.getGlobalSettings();
        const fetchedValues = {
          limit: settings.globalBalanceLimit?.toString() || "",
          botId: settings.telegramBotId || "",
          chatId: settings.telegramChatId || "",
        };
        setLimit(fetchedValues.limit);
        setBotId(fetchedValues.botId);
        setChatId(fetchedValues.chatId);
        setInitialValues(fetchedValues); // keep snapshot
      } catch (error) {
        toast.error("Failed to fetch settings.");
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);
      await userService.updateGlobalBalanceLimit(Number(limit));
      await userService.updateTelegramConfig(botId, chatId);
      toast.success("Settings saved successfully!");
      // after saving, reset baseline
      setInitialValues({ limit, botId, chatId });
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  // check if values have changed
  const hasChanges =
    limit !== initialValues.limit ||
    botId !== initialValues.botId ||
    chatId !== initialValues.chatId;

  return (
    <div className="flex flex-col w-full">
      <header className="rounded-lg sm:text-start text-center bg-[#474747] text-white w-full p-3">
        <h1 className="md:text-2xl text-lg font-bold md:text-left text-center">
          {t("Global Balance Limit")}
        </h1>
      </header>

      <div className="flex flex-col mt-[50px] gap-3 w-full sm:w-[349px] md:w-[540px] lg:w-[640px]">
        <input
          value={limit}
          placeholder="Global Balance Limit"
          onChange={(e) => setLimit(e.target.value)}
          className="border text-black rounded-md px-3 py-2 border-[#ccc]"
        />

        <input
          type="text"
          value={botId}
          placeholder="Telegram Bot ID"
          onChange={(e) => setBotId(e.target.value)}
          className="border text-black rounded-md px-3 py-2 border-[#ccc]"
        />

        <input
          type="text"
          value={chatId}
          placeholder="Telegram Chat ID"
          onChange={(e) => setChatId(e.target.value)}
          className="border text-black rounded-md px-3 py-2 border-[#ccc]"
        />

        <button
          onClick={handleSave}
          disabled={loading || !hasChanges}
          className={`bg-primary text-white px-4 mt-[20px] py-2 rounded-md hover:bg-primary/80 transition ${
            loading || !hasChanges ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          {loading ? "Saving..." : "Save Settings"}
        </button>
      </div>
    </div>
  );
};

export default GlobalBalanceLimit;